import methodologyEvaluation from "@/assets/chapter-intro-methodology-evaluation.jpg";
import methodologyInquiry from "@/assets/chapter-intro-methodology-inquiry.jpg";
import methodologyProcess from "@/assets/chapter-intro-methodology-process.jpg";
import programmingCoding from "@/assets/chapter-intro-programming-coding.jpg";
import programmingDebugging from "@/assets/chapter-intro-programming-debugging.jpg";
import programmingTesting from "@/assets/chapter-intro-programming-testing.jpg";

const PROGRAMMING_ILLUSTRATIONS = [
  programmingCoding,
  programmingDebugging,
  programmingTesting,
] as const;

const METHODOLOGY_ILLUSTRATIONS = [
  methodologyProcess,
  methodologyInquiry,
  methodologyEvaluation,
] as const;

const illustrationSetForCategory = (
  category: string | null
): readonly string[] | null => {
  if (category === "code") return PROGRAMMING_ILLUSTRATIONS;
  if (category === "methods") return METHODOLOGY_ILLUSTRATIONS;
  return null;
};

/** Stable across renders so unveiling a chapter does not swap the image. */
const hashChapterId = (chapterId: string): number => {
  let hash = 0;
  for (let index = 0; index < chapterId.length; index += 1) {
    hash = (Math.imul(hash, 31) + chapterId.charCodeAt(index)) >>> 0;
  }
  return hash;
};

/**
 * Chapter-intro artwork for a course category. Programming and methodology
 * each have their own set. Every other category has no illustration.
 */
const chapterIntroIllustration = (
  category: string | null,
  chapterId: string
): string | null => {
  const illustrations = illustrationSetForCategory(category);
  if (!illustrations) return null;
  return illustrations[hashChapterId(chapterId) % illustrations.length];
};

export { chapterIntroIllustration };
